export default {
  offers: [
    {
      id: 'Grabaut_Zero_MB',
      banner: {
        textMap: {
          title: 'Tarjeta Crédito HSBC Zero Pre autorizada*',
          text: 'Limite de Crédito $10,000 M.N.  *Para contratar revisa las condiciones de la oferta',
          applyButton: 'Aceptar',
        },
        background: {
          color: 'jade',
          image: '/images/Zero-20220525.jpg',
        },
        button: {
          url:
            'https://pre-approved-cc-mx-stub.apps.cf.wgdc-drn-03.cloud.uk.hsbc/?offerId=Grabaut_Zero_MB&locale=es',
        },
      },
    },
    {
      id: 'Grabaut_2NOW_MB',
      banner: {
        textMap: {
          title: 'Tarjeta de Crédito HSBC 2Now  Pre autorizada*',
          text: 'Límite de Crédito $10,000 M.N.  *Para contratar revisa las condiciones de la oferta',
          applyButton: 'Aceptar',
        },
        background: {
          color: 'jade',
          image: '/images/2now-20220525.jpg',
        },
        button: {
          url:
            'https://pre-approved-cc-mx-stub.apps.cf.wgdc-drn-03.cloud.uk.hsbc/?offerId=Grabaut_2NOW_MB&locale=es',
        },
      },
    },
    {
      id: 'Grabaut_P_MB',
      banner: {
        textMap: {
          title: 'Tarjeta Crédito HSBC Premier World Elite Pre autorizada*',
          text: 'Limite de Crédito $10,000 M.N.  *Para contratar revise las condiciones de la oferta',
          applyButton: 'Aceptar',
        },
        background: {
          color: 'jade',
          image: '/images/HSBC-Premier-20220711.jpg',
        },
        button: {
          url:
            'https://pre-approved-cc-mx-stub.apps.cf.wgdc-drn-03.cloud.uk.hsbc/?offerId=Grabaut_P_MB&locale=es',
        },
      },
    },
    {
      id: 'Grabaut_AIR_MB',
      banner: {
        textMap: {
          title: 'Tarjeta Crédito HSBC AIR Pre autorizada*',
          text: 'Limite de Crédito $10,000 M.N.  *Para contratar revisa las condiciones de la oferta',
          applyButton: 'Aceptar',
        },
        background: {
          color: 'jade',
          image: '/images/Air-20220525.jpg',
        },
        button: {
          url:
            'https://pre-approved-cc-mx-stub.apps.cf.wgdc-drn-03.cloud.uk.hsbc/?offerId=Grabaut_AIR_MB&locale=es',
        },
      },
    },
    {
      id: 'Grabaut_VIVA_MB',
      banner: {
        textMap: {
          title: 'Tienes una Tarjeta de Crédito HSBC VIVA Pre aprobada*',
          text: 'Límite de crédito de $50,000.00 M.N. *Para contratar, revisa las condiciones de la oferta',
          applyButton: 'Aceptar',
        },
        background: {
          color: 'jade',
          image: '/images/Viva-v1-20220816.jpg',
        },
        button: {
          url:
            'https://pre-approved-cc-mx-stub.apps.cf.wgdc-drn-03.cloud.uk.hsbc/?offerId=Grabaut_VIVA_MB&locale=es',
        },
      },
    },
    {
      id: 'Grabaut_VIVA_PLUS_MB',
      banner: {
        textMap: {
          title: 'Tienes una Tarjeta de Crédito HSBC VIVA PLUS Pre aprobada*',
          text: 'Límite de crédito de $50,000.00 M.N. *Para contratar, revisa las condiciones de la oferta',
          applyButton: 'Aceptar',
        },
        background: {
          color: 'jade',
          image: '/images/Viva_Plus-v1-20220816.jpg',
        },
        button: {
          url:
            'https://pre-approved-cc-mx-stub.apps.cf.wgdc-drn-03.cloud.uk.hsbc/?offerId=Grabaut_VIVA_PLUS_MB&locale=es',
        },
      },
    },
  ],
};
